module.exports = __webpack_public_path__ + "static/media/Icon-Writer.b8a4cdb2.png";